import styles from "./Training.module.css";

const Training = () => {
  return (
    <div>
      <div className="section">
        <div className={styles.trainingContainer}>
          <div className={styles.trainingSection}>
            <div className={styles.trainingMessage}>
              <div className={styles.messageHeading}>
                <h3>
                  <span>لماذا نحن؟</span>
                </h3>
                <h3>تعزيز قابلية التوظيف</h3>
              </div>
              <div className={styles.messageText}>
                <p>
                  بفضل خبرتهم العملية ومجموعة المهارات ذات الصلة لديهم، ستكون
                  للخريجين ميزة تنافسية في سوق العمل. وبالتالي، سيكونون مطلوبين
                  لدى أصحاب العمل الذين يقدرون الكفاءة والخبرة العملية
                </p>
              </div>
            </div>
            <div className={styles.trainingCards}>
              <div className={styles.trainingSingleCard}>
                <h3>التدريب ذو الصلة بالصناعة</h3>
                <p>
                  نعمل عن كثب مع المحترفين والخبراء في الصناعة لتطوير برامج
                  التدريب لدينا. نعطي الأولوية لتعليم المهارات والكفاءات
                  المطلوبة بشدة في سوق العمل
                </p>
              </div>
              <div className={styles.trainingSingleCard}>
                <h3>شراكات صناعية</h3>
                <p>
                  نتعاون مع الشركات والمؤسسات الرائدة لتوفير فرص التدريب المهني
                  والتحصّل على رؤى صناعية. تلك الشراكات تعرّض مرشحينا لبيئات عمل
                  حقيقية وتسهل فرص التواصل والشبكات
                </p>
              </div>
              <div className={styles.trainingSingleCard}>
                <h3>التدريب العملي</h3>
                <p>
                  نولي أهمية كبيرة للتعلم العملي وتجارب العمل الفعلية. يشارك
                  المرشحون في مشاريع حقيقية ومحاكاة لتطوير مهارات حل المشكلات
                  لديهم. يتم ذلك في الصيدليات المجتمعية وفي صناعة المجال
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Training;
